"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTotalValue = void 0;
var determineMinimumPriceByKeyword_1 = require("./determineMinimumPriceByKeyword");
var calcRoadConstructionPrice_1 = require("./calcRoadConstructionPrice");
// 合計金額を更新する関数
var updateTotalValue = function () {
    console.log('updateTotalValue');
    // 合計金額の計算用のinput
    var targetInput = document.querySelector('input[name="input_23"]');
    // 合計金額を表示する要素
    var totalPriceInput = document.querySelector('input[name="input_37"]');
    // 最低見積金額を表示する要素
    var minPriceDisplay = document.querySelector('.price-info p');
    if (targetInput !== null && totalPriceInput !== null) {
        // プロパティの直接的な変更も監視
        Object.defineProperty(targetInput, 'value', {
            set: function (newValue) {
                var safeValue = setTargetInputValue(newValue);
                var ifRoadConstruction = window.location.pathname.includes('road-construction');
                var totalPrice = ifRoadConstruction
                    ? (0, calcRoadConstructionPrice_1.calcRoadConstructionPrice)(safeValue) // 道路工事の場合は諸経費を追加する
                    : safeValue;
                var minPrice = (0, determineMinimumPriceByKeyword_1.determineMinimumPriceByKeyword)(totalPrice);
                if (minPriceDisplay !== null) {
                    minPriceDisplay.textContent = "\u6700\u4F4E\u898B\u7A4D\u91D1\u984D \u00A5".concat(minPrice.toLocaleString());
                }
                // 最低金額と比較して高い方を採用
                var finalPrice = Math.max(totalPrice, minPrice);
                console.log('Value Change:', finalPrice, "(original: ".concat(totalPrice, ", minimum: ").concat(minPrice, ")"));
                this.setAttribute('value', safeValue.toString());
                totalPriceInput.value = finalPrice.toString(); // 最低金額まで引き上げた値をセット
            },
            get: function () {
                return this.getAttribute('value');
            }
        });
    }
};
exports.updateTotalValue = updateTotalValue;
// 入力値を数値に変換する関数
var setTargetInputValue = function (newValue) {
    // 数字、小数点、マイナス記号以外の文字を除去し、数値に変換
    var numericValue = Number.parseFloat(newValue.replace(/[^0-9.-]+/g, ''));
    // 数値に変換できない場合は0を返し、それ以外は変換された数値を返す
    return Number.isNaN(numericValue) ? 0 : numericValue;
};
